import { connect, Dispatch } from 'react-redux';
import { MobileMenuToggle } from './component';
import { OpenMobileMenuAction } from '../menu/actions';
import { AppState } from 'pages/app/state';

function mapStateToProps({}: AppState) { return { }; }

function mapDisptachToProps(dispatch: Dispatch<OpenMobileMenuAction>): object {
  return {
    toggleInput: () => dispatch(new OpenMobileMenuAction()),
  };
}

export default connect(mapStateToProps, mapDisptachToProps)(MobileMenuToggle);



// WEBPACK FOOTER //
// ./src/components/mobile-menu-toggle/container.ts